<template>
  <div class="calculator">
    <!--    <b-alert fade :show="dismissCountDown" variant="warning" @dismiss-count-down="countDownChanged">-->
    <!--      <div class="d-flex" style="col or: #fff">-->
    <!--        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="white"-->
    <!--             class="align-self-center mr-2 bi bi-exclamation-triangle-fill" viewBox="0 0 16 16">-->
    <!--          <path-->
    <!--              d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>-->
    <!--        </svg>-->
    <!--        <div class="align-self-center">-->
    <!--          <div v-for="(mError, index) in error.split('.')" :key="`err-${index}`">-->
    <!--            {{ mError }}-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </b-alert>-->

    <!--    <b-modal id="error-modal" title="Chyba" hide-footer>-->
    <!--      <div class="my-4 modal-msg">{{ errMsg }}</div>-->

    <!--      <b-button class="mt-3 modal-btn" block @click="$bvModal.hide('error-modal')">Ok</b-button>-->
    <!--    </b-modal>-->


    <b-modal no-close-on-backdrop no-close-on-esc centered id="success-modal" hide-footer hide-header>
      <!-- <div class="modalImage">
        <img src="../assets/success.png" alt="">
      </div> -->

      <div class="tutorialBanner">
        <img class="agentBannerImg" src="https://cdn.prod.website-files.com/648b04f9d8e52d9524912b4a/6836d86cdbc2b695a9398864_dp_avatar_new.png">
      </div>

      <div class="modal-text">
        <h2>Podarilo sa 💪</h2>
        <div>
          pokračujte do klientskej sekcie aby ste videli konkrétne možnosti financovania, nájdete tam aj moju vizitku 😊
        </div>
      </div>

      <div class="inline-div">
        <a :href="`https://app.bankari.sk/?r_token=${getRefresh()}`"
           class="next-btn registracia_dokoncena"
           @click="$bvModal.hide('success-modal')">Poďme ďalej</a>
      </div>
    </b-modal>

    <b-modal centered id="2fa-success-modal" hide-footer hide-header>
      <div class="modalImage">
        <img src="../assets/success.png" alt="">
      </div>

      <div class="modal-text">
        <h2>Super,</h2>
        <div>
          Overenie prebehlo úspešne. Pokračujte ďalej a zaregistrujte sa pomocou google účtu, alebo emailu a hesla.
        </div>
      </div>

      <div class="inline-div">
        <div class="next-btn registracia_dokoncena"
             @click="$bvModal.hide('2fa-success-modal')">Registrovať
        </div>
      </div>
    </b-modal>

    <b-modal centered id="error-modal" hide-footer hide-header>
      <div class="modalImage">
        <img src="../assets/exclamation-mark.png" alt="">
      </div>

      <div class="modal-text">
        <h2>Skúste to znova</h2>
        <p>
          {{ errMsg }}
        </p>
      </div>

      <div class="inline-div">
        <div class="next-btn" @click="$bvModal.hide('error-modal')">Skúsiť znova</div>
      </div>
    </b-modal>

    <b-modal centered id="error-modal-diety" hide-footer hide-header>
      <div class="modalImage">
        <img src="../assets/exclamation-mark.png" alt="">
      </div>

      <div class="modal-text">
        <h2>Chyba,</h2>
        <p>Pre zvolené obdobie sú už diéty špecifikované</p>
      </div>

      <div class="inline-div">
        <div class="next-btn"
             @click="$bvModal.hide('error-modal-diety')">Skúsiť znova
        </div>
      </div>
    </b-modal>

    <div class="showCalculator" @click="toggleCalculator">
      <div class="showCalculatorText">HYPOKALKULAČKA</div>
      <div class="showCalculatorText2">Máš na to?</div>
      <div class="showCalculatorIcon"></div>
      <a href="https://www.bankari.sk/affiliate" target="_blank" class="affiliateBadge">
        <img class="darkBadge"
             src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/655329153dfa77637ac4d1c7_powered%20by.svg">
        <img class="lightBadge"
             src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/65533c07476243fbff41ad58_powered%20by%20white.svg">
      </a>
    </div>

    <div class="analyza-grid">
      <div class="bannerV2">
        <div class="bannerV2text">Spočítajte si financovanie na počkanie</div>
        <div class="bannerV2subtext">Prepočet hypotéky na základe vášho príjmu je s presnosťou 99 %</div>
      </div>
      <div class="bannerV2notext">
        <div class="bannerV2text">Buďte pripravený na obhliadku</div>
        <div class="bannerV2subtext">prepočet hypotéky na základe vášho príjmu je s presnosťou 99 %</div>
      </div>
      <div class="questionare">
        <div class="chat-extern-domain" id="chat-extern-domain-id">
          <!-- <div id="chat-trigger">
            <img class="ChatCalloutImg"
                 src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/65035bb5d6125674171e27e7_chat%20icon%20dark.svg">
            <div class="ChatCallout">Máte otázku? Spýtajte sa</div>
          </div> -->
          <!-- <banner-remarketing></banner-remarketing> -->
        </div>
        <div class="question-1">

          <div v-if="state === 0" data-aos="fade-down" class="question1V2">
            <!-- prvý slíde analýzy -->
            <div class="questionare-title MGbottom20px">
              <div class="question-step"><span class="green">Na aký účel</span> Vám vypočítame hypotéku?
              </div>
            </div>

            <div data-w-id="340c02b6-12ea-ee59-301a-06fde7df4562"
                 style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
                 class="answers-block">
              <Button first :value="'nadobudnutie'"
                      :inner="'Kúpa nehnuteľnosti'" @select="handleEvent($event)"
                      :next="1"></Button>
              <Button first :value="'refinancovanie'"
                      :inner="'Chcem refinancovať úver'" @select="handleEvent($event)" :next="25"></Button>
              <!-- <Button first :value="'uverovy_certifikat'"
                      :inner="'Hypotéka so schválením bez nehnuteľnosti'" @select="handleEvent($event)"
                      :next="form[state].next"></Button> -->
              <Button first :value="'americka_hypo'"
                      :inner="'Americká / bezúčelová hypotéka'" @select="handleEvent($event)"
                      :next="23"></Button>
            </div>
          </div>

          <div v-if="state === 1" data-aos="fade-down" class="question1V2">
            <!-- učel nadobudnutie -->
            <div class="questionare-title">
              <div class="question-step replaceable4"></div>
            </div>
            <div
                style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
                class="answers-block">
              <div class="income-calculator">
                <div class="questionare-text MGbottom10px replaceable1"></div>
                <!--                <div-->
                <!--                    class="questionare-text bold big">{{ formData.propertyValue.toLocaleString() }} EUR-->
                <!--                </div>-->
                <invisible-input v-model="formData.propertyValue" type="number" :min="0" :max="1000000"
                                 after="EUR"></invisible-input>

                <slider :value-prop="formData.propertyValue" :step="1000" :min="0" :max="1000000"
                        @change="handleEvent($event)"
                        data-ref="propertyValue"></slider>
              </div>
              <div class="income-calculator">
                <div class="questionare-text MGbottom10px replaceable2">
                </div>
                <div class="ltvWrapper">
                  <invisible-input v-model="formData.mortgage.suma_nadobudnutie" type="number" :min="0"
                                   :max="(formData.propertyValue * 0.9) + 1000"
                                   after="EUR">
                  </invisible-input>

                  <div class="ltvSelector">
                    <div class="arrows" style="user-select:none;">
                      <svg @click="handleLtvChange(true)" class="ltv-control" style="user-select:none;" width="11"
                           height="8"
                           viewBox="0 0 11 8" fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 6.5L5.5 2L1 6.5" stroke-width="2"/>
                      </svg>

                      <svg @click="handleLtvChange(false)" class="ltv-control" style="user-select:none;" width="11"
                           height="7"
                           viewBox="0 0 11 7" fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L5.5 5.5L10 1" stroke-width="2"/>
                      </svg>

                    </div>
                    <div class="questionare-text bold" style="user-select:none;">{{ LTV ? parseInt(LTV) : 0 }}%</div>
                  </div>
                </div>
                <slider :value-prop="formData.mortgage.suma_nadobudnutie" :data-ref="'mortgage.suma_nadobudnutie'"
                        :step="1000" :min="0"
                        :max="(formData.propertyValue * 0.9) + 1000"
                        :disabled="!formData.propertyValue"
                        @change="handleEvent($event)"
                >
                </slider>
              </div>
            </div>
          </div>

          <!--          <div v-if="state === 2" data-aos="fade-down">-->
          <!--            &lt;!&ndash; ucel refinancovanie (neznámy slide) &ndash;&gt;-->
          <!--            <div class="questionare-title MGbottom20px"></div>-->
          <!--            <div-->
          <!--                style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"-->
          <!--                class="answers-block">-->
          <!--              <div class="income-calculator">-->
          <!--                <div class="questionare-text margin-bottom">Aký je zostatok Vašej hypotéky?</div>-->
          <!--                <div-->
          <!--                    class="questionare-text bold big">{{ formData.mortgage.suma_refinancovanie.toLocaleString() }} EUR-->
          <!--                </div>-->
          <!--                <slider :value-prop="formData.mortgage.suma_refinancovanie" :data-ref="'mortgage.suma_refinancovanie'"-->
          <!--                        :step="1000"-->
          <!--                        :min="10000" :max="500000"-->
          <!--                        @change="handleEvent($event)"></slider>-->
          <!--              </div>-->
          <!--              <div class="income-calculator">-->
          <!--                <div class="questionare-text margin-bottom">Máte záujem aj o navýšenie úveru, o akú sumu?</div>-->
          <!--                <div class="div-block-87">-->
          <!--                  <div-->
          <!--                      class="questionare-text bold big">{{ formData.mortgage.suma_bezucel.toLocaleString() }} EUR-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--                <slider :value-prop="formData.mortgage.suma_bezucel" :data-ref="'mortgage.suma_bezucel'" :step="1000"-->
          <!--                        :min="0" :max="300000"-->
          <!--                        @change="handleEvent($event)"></slider>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->

          <div v-if="state === 3" data-aos="fade-down">
            <!-- hlavný prijem slide po výbere účelu-->
            <div class="questionare-title MGbottom20px">
              <div class="question-step">Aký je Váš<span class="green"> hlavný príjem?</span></div>
            </div>
            <div
                style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
                class="answers-block">
              <Button :value="'trvaly_pracovny_pomer'" :inner="'Som zamestnaný'"
                      @select="handleEvent($event)"
                      :next="4"></Button>
              <Button :value="'prijem_zivnostnika'" :inner="'Podnikám ako živnostník'"
                      @select="handleEvent($event)" :next="5"></Button>
              <Button :value="'prijem_z_sro'" :inner="'Podnikám v rámci SRO'"
                      @select="handleEvent($event)"
                      :next="6"></Button>
            </div>
            <div class="infoBaner">Na výpočet presných a reálných ponúk potrebujeme vedieť druh a výšku príjmu
            </div>
          </div>

          <div v-if="state === 4" data-aos="fade-down">
            <!-- príjem zo zamestnania slide žiadateľ -->
            <div class="questionare-title"></div>
            <div
                style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
                class="answers-block">
              <div class="income-calculator">
                <income-displayer :fullfilling="fullfilling"
                                  :income="formData.income.mainIncome.suma"
                ></income-displayer>
                <div
                    class="questionare-text mini MGtop10px">*pre výpočet zadajte Vašu výplatu najlepšie za posledných 6
                  mesiacov, minimálne však 3 mesiace (v čistom)
                </div>
              </div>
            </div>

            <div>
              <b-collapse v-for="(month, index) in formData.lastMonths" v-model="collapseMap[index]"
                          class="MGbottom10px"
                          :key="`ci-${index}`">
                <value-input
                    months
                    :init-value="month.value"
                    :data-ref="`lastMonths[${index}].value`"
                    :key="`vi-${index}`" :title="month.name"
                    :vanishable="index === formData.lastMonths.length - 1 && index !== 2 && !collapsing"
                    @change="handleEvent($event)"
                    @vanish="hideMonth"
                    @focusout="getAverageIncome"
                ></value-input>
              </b-collapse>
            </div>

            <div class="cta-text-small custom-link-no-u"
                 v-if="formData.lastMonths.length < 12 && formData.lastMonths[formData.lastMonths.length - 1].value"
                 @click="expandNewMonth">+ pridať ďalší mesiac
            </div>
          </div>

          <div v-if="state === 5" data-aos="fade-down">
            <!-- príjem zo živnosti žiadateľ -->
            <div class="questionare-title"></div>
            <div
                style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
                class="answers-block">
              <div class="income-calculator">
                <income-displayer :fullfilling="fullfilling"
                                  :income="formData.income.mainIncome.suma"
                ></income-displayer>
                <div
                    class="questionare-text mini MGtop10px">*pre výpočet Vášho priemerného mesačného príjmu zadajte
                  vstupné informácie
                </div>
              </div>

              <div>
                <value-input @change="handleEvent($event)"
                             :data-ref="'income.selfEmployed.trzby'"
                             :init-value="formData.income.selfEmployed.trzby"
                             :title="'Tržby'"
                             @focusout="getAverageIncome"
                ></value-input>

                <dropdown-select style="margin-bottom: 40px" :options="[
                      {value: 'true', text: 'Paušálne'},
                      {value: 'false', text: 'Reálne'},
                  ]"
                                 :id="0"
                                 :name="'Výdavky'"
                                 no-input
                                 @select="handleEvent($event); getAverageIncome()"
                                 :init-value="formData.income.selfEmployed.pausalne_vydavky"
                                 data-ref="income.selfEmployed.pausalne_vydavky"
                ></dropdown-select>

                <b-collapse v-model="vydavkyCollapsed" id="vydavky-collapse" class="my-2">
                  <value-input @change="handleEvent($event)"
                               :data-ref="'income.selfEmployed.minulorocne_vydavky'"
                               :init-value="formData.income.selfEmployed.minulorocne_vydavky"
                               :title="'Suma'"
                               @focusout="getAverageIncome"></value-input>
                </b-collapse>

                <dropdown-select  style="display: none;" class="my-2" :options="[
                      {value: 'monthly', text: 'Výpočtom'},
                      {value: 'yearly', text: 'Z priznania'},
                      {value: 'dont-know', text: 'Neviem'},
                  ]"
                                 :id="1"
                                 name="Zaplatené poistné"
                                 no-input
                                 @select="handleEvent($event); getAverageIncome()"
                                 :init-value="formData.wayOfCalculatingPoistne"
                                 data-ref="wayOfCalculatingPoistne"
                ></dropdown-select>

                <b-collapse style="display: none;" v-model="poistneCollapsed">
                  <value-input class="my-2" @change="handleEvent($event)"
                               :data-ref="'income.selfEmployed.rocne_poistne'"
                               :init-value="formData.income.selfEmployed.rocne_poistne"
                               :title="formData.wayOfCalculatingPoistne === 'monthly' ? 'Mesačné poistné' : 'Ročné poistné'"
                               @focusout="getAverageIncome"
                  ></value-input>
                </b-collapse>
              </div>
            </div>
          </div>

          <div v-if="state === 6" data-aos="fade-down">
            <!-- príjem z SRO žiadateľ -->
            <div class="questionare-title"></div>
            <div
                style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
                class="answers-block">
              <div class="income-calculator">
                <income-displayer :fullfilling="fullfilling"
                                  :income="formData.income.mainIncome.suma"></income-displayer>

                <div
                    class="questionare-text mini MGtop10px">*pre výpočet priemerného mesačného príjmu zadajte vstupné
                  informácie nižšie
                </div>
              </div>

              <div>
                <value-input class="my-2" @change="handleEvent($event)"
                             :data-ref="'income.company.trzby'"
                             :init-value="formData.income.company.trzby" :title="'Tržby'"
                             @focusout="getAverageIncome"
                ></value-input>

                <value-input class="my-2" @change="handleEvent($event)"
                             :data-ref="'income.company.zisk'"
                             :init-value="formData.income.company.zisk" :title="'Zisk'"
                             :min="-1000000"
                             @focusout="getAverageIncome"
                ></value-input>

                <value-input class="my-2" :max="100" :min="0" :after="'%'"
                             @change="handleEvent($event)"
                             :data-ref="'income.company.podiel'"
                             :init-value="formData.income.company.podiel" :title="'Podiel'"
                             @focusout="getAverageIncome"
                ></value-input>
              </div>
            </div>
          </div>

          <div v-if="state === 7" data-aos="fade-down">
            <!-- hlavný príjem spolužiadateľa z managera -->
            <div>
              <div class="questionare-title MGbottom10px">
                <div class="question-step">Aký je <span class="green">hlavný príjem</span> spolužiadateľa?</div>
              </div>
              <div
                  style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
                  class="answers-block">
                <Button :value="'trvaly_pracovny_pomer'" :inner="'Príjem zo zamestnania'"
                        @select="handleEvent($event)"
                        :next="8"></Button>
                <Button :value="'prijem_zivnostnika'"
                        :inner="'Podniká ako živnostník'"
                        @select="handleEvent($event)" :next="5"></Button>
                <Button :value="'prijem_z_sro'" :inner="'Podniká v rámci SRO'"
                        @select="handleEvent($event)"
                        :next="10"></Button>
                <Button value="" :inner="'Iba vedľajší'"
                        @select="handleEvent($event)"
                        :next="11"></Button>
              </div>
            </div>
          </div>

          <div v-if="state === 8" data-aos="fade-down">
            <!-- príjem zo zamestnania spolužiadateľ -->
            <div class="questionare-title"></div>
            <div
                style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
                class="answers-block">
              <div class="income-calculator">

                <income-displayer :fullfilling="fullfilling"
                                  :income="formData.income.mainIncome.suma"
                ></income-displayer>
                <div
                    class="questionare-text mini">*pre výpočet zadajte výplatu spolužiadateľa minimálne za posledné 3
                  mesiace, najlepšie však 6 mesiacov (v čistom)

                </div>
              </div>

              <div>
                <b-collapse v-for="(month, index) in formData.lastMonths" v-model="collapseMap[index]"
                            class="my-2"
                            :key="`ci-${index}`">
                  <value-input
                      :months="true"
                      :init-value="month.value"
                      :data-ref="`lastMonths[${index}].value`"
                      :key="`vi-${index}`" :title="month.name"
                      :vanishable="index === formData.lastMonths.length - 1 && index !== 2 && !collapsing"
                      @change="handleEvent($event)"
                      @vanish="hideMonth"
                      @focusout="getAverageIncome"
                  ></value-input>
                </b-collapse>
              </div>

              <div class="cta-text-small custom-link-no-u my-2 mx-auto fit-content"
                   v-if="formData.lastMonths.length < 12"
                   @click="expandNewMonth">+ pridať ďalší mesiac
              </div>
            </div>
          </div>

          <div v-if="state === 9" data-aos="fade-down">
            <!-- príjem zo živnosti spolužiadateľ -->
            <!--NEPOUŽÍVA SA-->
            <div class="questionare-title "></div>
            <div
                style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
                class="answers-block">
              <div class="income-calculator">
                <income-displayer :fullfilling="fullfilling"
                                  :income="formData.income.mainIncome.suma"
                ></income-displayer>
                <div
                    class="questionare-text mini">*pre výpočet priemerného mesačného príjmu spolužiadateľa zadajte
                  vstupné informácie
                </div>

              </div>

              <div>
                <value-input @change="handleEvent($event)"
                             :data-ref="'income.selfEmployed.trzby'"
                             :init-value="formData.income.selfEmployed.trzby"
                             :title="'Tržby'"
                             @focusout="getAverageIncome"
                ></value-input>
                <dropdown-select  :options="[
                      {value: 'pausal', text: 'Paušálne'},
                  ]" :name="'Výdavky'"
                                 @select="handleEvent($event); getAverageIncome({target: {value: $event.value}});"
                                 :init-value="formData.income.selfEmployed.minulorocne_vydavky"
                                 data-ref="income.selfEmployed.minulorocne_vydavky" @focusout="getAverageIncome"
                ></dropdown-select>
                <value-input @change="handleEvent($event)"
                             :data-ref="'income.selfEmployed.rocne_poistne'"
                             :init-value="formData.income.selfEmployed.rocne_poistne"
                             :title="'Poistné'"
                             @focusout="getAverageIncome"
                ></value-input>
              </div>

            </div>
          </div>

          <div v-if="state === 10" data-aos="fade-down">
            <!-- príjem z SRO spolužiadateľ -->
            <div class="questionare-title "></div>
            <div
                style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
                class="answers-block">
              <div class="income-calculator">
                <income-displayer :fullfilling="fullfilling"
                                  :income="formData.income.mainIncome.suma"></income-displayer>
                <div
                    class="questionare-text mini">*pre výpočet priemerného mesačného príjmu spolužiadateľa zadajte
                  vstupné informácie
                </div>
              </div>

              <div>
                <value-input class="my-2" @change="handleEvent($event)"
                             :data-ref="'income.company.trzby'"
                             :init-value="formData.income.company.trzby" :title="'Tržby'"
                             @focusout="getAverageIncome"
                ></value-input>
                <value-input class="my-2" @change="handleEvent($event)"
                             :data-ref="'income.company.zisk'"
                             :init-value="formData.income.company.zisk" :title="'Zisk'"
                             :min="-1000000"
                             @focusout="getAverageIncome"
                ></value-input>
                <value-input class="my-2" :max="100" :min="0" :after="'%'"
                             @change="handleEvent($event)"
                             :data-ref="'income.company.podiel'"
                             :init-value="formData.income.company.podiel" :title="'Podiel'"
                             @focusout="getAverageIncome"
                ></value-input>
              </div>

            </div>
          </div>

          <div v-if="state === 11" data-aos="fade-down">
            <div class="questionare-title vertical">
              <div class="question-step" v-html="form[state].displayName"></div>
            </div>

            <Button :value="[12, 13]" :inner="'Príjem z prenájmu'" @select="handleEvent($event)"
                    :next="seenSideIncomeOptions || formData.income.client ? formData.income.client === 'applicant' ? 12 : 13 : 20"></Button>
            <Button
                v-if="formData.income.client === 'applicant' ? !responseData.incomes.applicant.filter(income => income.druh === 'dochodca')[0] : !responseData.incomes.coApplicant.filter(income => income.druh === 'dochodca')[0]"
                :value="[14, 15]" :inner="'Dôchodok(napr. výsluhový)'" @select="handleEvent($event)"
                :next="seenSideIncomeOptions || formData.income.client ? formData.income.client === 'applicant' ? 14 : 15 : 20"></Button>
            <!--            <Button :value="[19, 19]" :inner="'Cestovné náhrady(diéty)'" @select="handleEvent($event)"-->
            <!--                    :next="seenSideIncomeOptions ? 19 : 20"></Button>-->
            <Button v-if="!hasSideIncomeParentalContribution" :value="[22, 22]" :inner="'Rodičovský príspevok'"
                    @select="handleEvent($event);"
                    :next="seenSideIncomeOptions || formData.income.client ? 22 : 20"></Button>
            <Button v-if="!seenSideIncomeOptions" value="" inner="Nie" @select="handleEvent($event)"
                    :next="18"></Button>
          </div>

          <div v-if="state === 12" data-aos="fade-down">
            <!-- príjem z prenájmu žiadateľ -->
            <div class="questionare-title"></div>
            <div
                style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
                class="answers-block">
              <div class="income-calculator">
                <div class="questionare-text MGbottom10px">Uveďte cenu nájmu, ktorú inkasujete:</div>
                <!--                <div-->
                <!--                    class="questionare-text bold big">-->
                <!--                  {{ formData.income.sideIncome.prijem_z_prenajmu_nehnutelnosti.toLocaleString() }} EUR-->
                <!--                </div>-->

                <invisible-input v-model="formData.income.sideIncome.prijem_z_prenajmu_nehnutelnosti" type="number"
                                 :min="0" :max="5000"
                                 after="EUR"></invisible-input>
                <slider :step="10" :min="0" :max="5000"
                        @change="handleEvent($event);"
                        :value-prop="formData.income.sideIncome.prijem_z_prenajmu_nehnutelnosti"
                        :data-ref="'income.sideIncome.prijem_z_prenajmu_nehnutelnosti'"></slider>

                <div
                    class="questionare-text mini">*cenu nájmu uveďte bez energii, ak ich máte na zmluve rozdelené
                </div>
              </div>

              <div class="income-calculator">
                <div class="questionare-text MGbottom10px">Ako dlho už prenajímate?</div>

                <date-picker title="prenajímam od" id="date-picker-0" @change="handleEvent"
                             data-ref="income.incomeFrom"
                             :init-value="formData.income.incomeFrom"></date-picker>
              </div>
              <!-- <b-overlay :show="fullfilling" class="mb-3">
                <div class="banks" v-if="responseData.banks.length">
                  <b-row v-for="(bank, index) in responseData.banks" :key="`bank-${index}`"
                         class="justify-content-between mx-0 my-1">
                    <b-col class="d-flex p-0">
                      <b-col class="align-self-center"><img :src="bank.image" alt="" width="35" height="30"></b-col>
                      <b-col class="align-self-center"> {{ bank.name }}</b-col>
                    </b-col>
                    <b-col class="text-right align-self-center" style="font-weight: 700">{{ bank.value }}</b-col>
                  </b-row>
                </div>

                <div v-else
                     style="background: white; border-radius: 5px; padding: 1rem;   color: #0B1953; font-weight: 500">Pre konkrétne riešenia potiahnite sliderom
                </div>
              </b-overlay> -->
            </div>
          </div>

          <div v-if="state === 13" data-aos="fade-down">
            <!-- príjem z prenájmu spolužiadateľ -->
            <div class="questionare-title"></div>
            <div
                style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
                class="answers-block">
              <div class="income-calculator">
                <div class="questionare-text MGbottom10px">Uveďte priemernú cenu nájmu</div>
                <!--                <div-->
                <!--                    class="questionare-text bold big">{{ formData.income.sideIncome.prijem_z_prenajmu_nehnutelnosti }}€-->
                <!--                </div>-->
                <invisible-input v-model="formData.income.sideIncome.prijem_z_prenajmu_nehnutelnosti" type="number"
                                 :min="0" :max="5000"
                                 after="EUR"></invisible-input>
                <slider @focusout="getBanksForRent" :step="10" :min="0" :max="5000" @change="handleEvent($event)"
                        :value-prop="formData.income.sideIncome.prijem_z_prenajmu_nehnutelnosti"
                        :data-ref="'income.sideIncome.prijem_z_prenajmu_nehnutelnosti'"></slider>
                <div class="questionare-text mini">*cenu nájmu uveďte bez energii, ak ich máte na zmluve rozdelené
                </div>
              </div>

              <div class="income-calculator">
                <div class="questionare-text MGbottom10px">Ako dlho už prenajímate?</div>
                <date-picker title="prenajímam od" id="date-picker-1" class="my-2" @change="handleEvent"
                             data-ref="income.incomeFrom"
                             :init-value="formData.income.incomeFrom"></date-picker>
              </div>
              <!-- <b-overlay :show="fullfilling" class="mb-3">
                <div class="banks" v-if="responseData.banks.length">
                  <b-row v-for="(bank, index) in responseData.banks" :key="`bank-${index}`"
                         class="justify-content-between mx-0 my-1">
                    <b-col class="d-flex p-0">
                      <b-col class="align-self-center"><img :src="bank.image" alt="" width="35" height="30"></b-col>
                      <b-col class="align-self-center"> {{ bank.name }}</b-col>
                    </b-col>
                    <b-col class="text-right align-self-center" style="font-weight: 700">{{ bank.value }}</b-col>
                  </b-row>
                </div>

                <div v-else
                     style="background: white; border-radius: 5px; padding: 1rem;   color: #0B1953; font-weight: 500">Pre konkrétne riešenia potiahnite sliderom
                </div>
              </b-overlay> -->
            </div>
          </div>

          <div v-if="state === 14" data-aos="fade-down">
            <!-- vedľajší príjem z dôchodku -->
            <div>
              <div
                  style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
                  class="answers-block">
                <div class="questionare-title MGbottom10px">
                  <div class="question-step">Mesačná suma <span class="green">vyplácaného dôchodku</span></div>
                </div>
                <div>
                  <value-input class="my-2" @change="handleEvent($event)"
                               :data-ref="'income.sideIncome.vysluhovy_dochodca'"
                               :init-value="formData.income.sideIncome.vysluhovy_dochodca"
                               :title="'Výsluhový'"></value-input>
                  <value-input class="my-2" @change="handleEvent($event)"
                               :data-ref="'income.sideIncome.starobny_dochodca'"
                               :init-value="formData.income.sideIncome.starobny_dochodca"
                               :title="'Starobný'"></value-input>
                  <value-input class="my-2" @change="handleEvent($event)"
                               :data-ref="'income.sideIncome.vdovsky_dochodca'"
                               :init-value="formData.income.sideIncome.vdovsky_dochodca"
                               :title="'Vdovský'"></value-input>
                  <value-input class="my-2" @change="handleEvent($event)"
                               :data-ref="'income.sideIncome.invalidny_dochodca_v_sr'"
                               :init-value="formData.income.sideIncome.invalidny_dochodca_v_sr"
                               :title="'Invalidný'"></value-input>
                </div>
              </div>
            </div>
          </div>

          <div v-if="state === 15" data-aos="fade-down">
            <!-- vedľajší príjem spoluziadateľa z dôchodku -->
            <div>
              <div
                  style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
                  class="answers-block">
                <div class="questionare-title MGbottom10px">
                  <div class="question-step">Mesačný príjem spolužiadateľa <span class="green">z dôchodku</span></div>
                </div>
                <div>
                  <value-input class="my-2" @change="handleEvent($event)"
                               :data-ref="'income.sideIncome.vysluhovy_dochodca'"
                               :init-value="formData.income.sideIncome.vysluhovy_dochodca"
                               :title="'Výsluhový'"></value-input>
                  <value-input class="my-2" @change="handleEvent($event)"
                               :data-ref="'income.sideIncome.starobny_dochodca'"
                               :init-value="formData.income.sideIncome.starobny_dochodca"
                               :title="'Starobný'"></value-input>
                  <value-input class="my-2" @change="handleEvent($event)"
                               :data-ref="'income.sideIncome.vdovsky_dochodca'"
                               :init-value="formData.income.sideIncome.vdovsky_dochodca"
                               :title="'Vdovský'"></value-input>
                  <value-input class="my-2" @change="handleEvent($event)"
                               :data-ref="'income.sideIncome.invalidny_dochodca_v_sr'"
                               :init-value="formData.income.sideIncome.invalidny_dochodca_v_sr"
                               :title="'Invalidný'"></value-input>
                </div>

              </div>
            </div>
          </div>

          <!--          <div-->
          <!--              v-if="state === 16 && formData.mortgage.ciel_prva_analyza === 'uverovy_certifikat'">-->
          <!--            <b-overlay :show="fullfilling" class="mb-3">-->
          <!--              <div class="questionare-title vertical">-->
          <!--                <div class="question-step">Gratulujeme, Váš príjem stačí na <strong>hypotéku vo výške</strong>:</div>-->
          <!--              </div>-->
          <!--              <div class="dti-a-dsti-result">-->
          <!--                <div id="w-node-d8b15c3a-a3e9-9b89-ba97-dff889e95688-753ff164"-->
          <!--                     data-w-id="d8b15c3a-a3e9-9b89-ba97-dff889e95688"-->
          <!--                     style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d; box-shadow: none!important;"-->
          <!--                     class="div-block-72 dtikalkulacka">-->
          <!--                  <div class="text-extra-big">{{ responseData.DTI.toLocaleString() }} EUR <span-->
          <!--                      class="upper-index-big">DTI</span></div>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--              <div class="questionare-title vertical">-->
          <!--                <div class="questionare-text text-left">teraz keď už vieme na čo máte, pomôžeme Vám vybrať banku a-->
          <!--                  nachystať-->
          <!--                  žiadosť pre:-->
          <!--                </div>-->
          <!--              </div>-->
          <!--              <div data-w-id="63334416-07e0-9808-495c-46c051dfd3a1"-->
          <!--                   style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"-->
          <!--                   class="answers-block">-->
          <!--                <Button @select="handleEvent($event)" :next="17" :inner="'Novú hypotéku na kúpu nehnuteľnosti'"-->
          <!--                        :value="'nadobudnutie'"></Button>-->
          <!--                <Button @select="handleEvent($event)" :next="17" :inner="'Refinancovanie starej hypotéky'"-->
          <!--                        :value="'refinancovanie'"></Button>-->
          <!--                <Button @select="handleEvent($event)" :next="17" :inner="'Hypotéka bez účelu (americká hypotéka)'"-->
          <!--                        :value="'americka_hypo'"></Button>-->
          <!--              </div>-->
          <!--            </b-overlay>-->
          <!--          </div>-->

          <div
              v-if="state === 16 && responseData.DTI" data-aos="fade-down">
            <b-overlay :show="fullfilling">
              <div class="income-calculator">
                <div
                    v-if="(applicant.mortgages[0].suma_nadobudnutie + applicant.mortgages[0].suma_refinancovanie + applicant.mortgages[0].suma_bezucel) <= responseData.DTI"
                    class="questionare-text bold">Gratulujeme, Váš príjem je postačujúci na <span class="green">
                  {{
                    applicant.mortgages[0].ciel_prva_analyza === "nadobudnutie" ? "nadobudnutie tejto nehnuteľnosti" : ["refinancovanie", "konsolidáciu"].includes(applicant.mortgages[0].ciel_prva_analyza) ? "refinancovanie" : applicant.mortgages[0].ciel_prva_analyza === "uverovy_certifikat" ? "takýto úver" : "americkú hypotéku"
                  }}</span>
                </div>
                <div v-else class="questionare-text bold">Váš príjem nepostačuje na
                  {{
                    applicant.mortgages[0].ciel_prva_analyza === "nadobudnutie" ? "nadobudnutie tejto nehnuteľnosti" : ["refinancovanie", "konsolidáciu"].includes(applicant.mortgages[0].ciel_prva_analyza) ? "refinancovanie" : applicant.mortgages[0].ciel_prva_analyza === "uverovy_certifikat" ? "úverový certifikát" : "americkú hypotéku"
                  }}
                </div>
              </div>
              <div class="income-calculator">
                <div class="questionare-text">Max. výška úveru</div>
                <div>
                  <div class="questionare-text bold big">{{ responseData.DTI.toLocaleString() }} EUR</div>
                </div>
              </div>

              <div class="income-calculator" v-if="applicant.mortgages[0].ciel_prva_analyza !== 'uverovy_certifikat'">
                <div class="questionare-text">Požadovaná výška úveru</div>
                <div>
                  <div class="questionare-text bold big"
                       :class="{red: (applicant.mortgages[0].suma_nadobudnutie + applicant.mortgages[0].suma_refinancovanie + applicant.mortgages[0].suma_bezucel) > responseData.DTI}">
                    {{
                      (applicant.mortgages[0].suma_nadobudnutie + applicant.mortgages[0].suma_refinancovanie + applicant.mortgages[0].suma_bezucel).toLocaleString()
                    }} EUR
                  </div>
                </div>
              </div>

              <div @click="history.push(state); state = 18"
                   v-if="(applicant.mortgages[0].suma_nadobudnutie + applicant.mortgages[0].suma_refinancovanie + applicant.mortgages[0].suma_bezucel) > responseData.DTI"
                   class="infoBaner replaceable3">Nevzdávajte sa, určite nájdeme riešenie, ako vám zabezpečiť nové
                bývanie. Pozrite si naše ponuky. 
              </div>

              <div class="income-calculator finalCtaBanner">
                <div class="businessCard">
                  <div class="businessCardPhoto"></div>
                  <div class="businessCardContact">
                    <div class="businessCardName">Mgr. Michaela Rosochová</div>
                    <a href="tel:+421940610948" class="businessCardContactCorvus">0940 610 948</a>
                  </div>
                </div>
                Poďme sa spolu pozrieť na ponuky financovania, alebo si rovno dohodnime obhliadku vzorového bytu.
              </div>

              <!--              <div-->
              <!--                  v-if="applicant.mortgages[0].suma_nadobudnutie <= responseData.DTI"-->
              <!--                  class="mt-2 d-flex flex-wrap font-weight-bold flex-row justify-content-between div-block-72 dtikalkulacka">-->
              <!--                <div class="align-self-center">Cena nehnuteľnosti</div>-->
              <!--                <div>-->
              <!--                  <div class="text-extra-big">{{ formData.propertyValue.toLocaleString() }} EUR</div>-->
              <!--                </div>-->
              <!--                <div style="flex-basis: 100%">-->
              <!--                  <slider :value-prop="formData.propertyValue" :step="1000"-->
              <!--                          :min="1000" @change="handleEvent($event)"-->
              <!--                          data-ref="propertyValue" :max="maxPropertyValue"></slider>-->
              <!--                </div>-->
              <!--              </div>-->
            </b-overlay>
          </div>

          <!--          <div v-if="(state === 16 && ['refinancovanie', 'americka_hypo'].includes(applicant.mortgages[0].hlavny_ucel))">-->
          <!--            <b-overlay :show="fullfilling" class="mb-3">-->

          <!--              <div class="questionare-title vertical">-->

          <!--                <div-->
          <!--                    v-if="applicant.mortgages[0].suma_refinancovanie + applicant.mortgages[0].suma_bezucel <= responseData.DTI"-->
          <!--                    class="question-step">Gratulujeme, Váš príjem-->
          <!--                  <strong>je dostatočný</strong> na refinancovanie starého úveru-->
          <!--                </div>-->
          <!--                <div v-else-if="applicant.mortgages[0].suma_refinancovanie <= responseData.DTI"-->
          <!--                     class="question-step">Je nám ľúto, Váš príjem-->
          <!--                  <strong>je dostatočný</strong> na refinancovanie, nie však navýšenie úveru-->
          <!--                </div>-->
          <!--                <div v-else class="question-step">Je nám ľúto, Váš príjem-->
          <!--                  <strong>nie je dostatočný</strong> na refinancovanie úveru v požadovanej výške-->
          <!--                </div>-->
          <!--              </div>-->

          <!--              <div-->
          <!--                  class="d-flex flex-wrap font-weight-bold flex-row justify-content-between div-block-72 dtikalkulacka"-->
          <!--                  style="box-shadow: none!important;">-->
          <!--                <div class="align-self-center">Max. výška úveru</div>-->
          <!--                <div>-->
          <!--                  <div class="text-extra-big">{{ responseData.DTI.toLocaleString() }} EUR <span-->
          <!--                      class="upper-index-big">DTI</span></div>-->
          <!--                </div>-->
          <!--              </div>-->

          <!--              <div-->
          <!--                  class="mt-2 d-flex flex-wrap font-weight-bold flex-row justify-content-between div-block-72 dtikalkulacka">-->
          <!--                <div class="align-self-center">Požadovaná výška úveru</div>-->
          <!--                <div>-->
          <!--                  <div class="text-extra-big"-->
          <!--                       :class="{red: applicant.mortgages[0].suma_refinancovanie + applicant.mortgages[0].suma_bezucel > responseData.DTI}">{{ (applicant.mortgages[0].suma_refinancovanie + formData.mortgage.suma_bezucel).toLocaleString() }} EUR-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--              </div>-->

          <!--              <div-->
          <!--                  v-if="formData.mortgage.suma_refinancovanie < responseData.DTI"-->
          <!--                  class="mt-2 d-flex flex-wrap font-weight-bold flex-row justify-content-between div-block-72 dtikalkulacka">-->
          <!--                <div class="align-self-center">Navýšenie o bezúčelovú časť</div>-->
          <!--                <div>-->
          <!--                  <div-->
          <!--                      class="text-extra-big">{{ formData.mortgage.suma_bezucel ? formData.mortgage.suma_bezucel.toLocaleString() : 0 }} EUR-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--                <div style="flex-basis: 100%">-->
          <!--                  <slider :value-prop="formData.mortgage.suma_bezucel" :step="1000"-->
          <!--                          @change="handleEvent($event)"-->
          <!--                          data-ref="mortgage.suma_bezucel" :max="maxIncreaseAmount"></slider>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </b-overlay>-->
          <!--          </div>-->


          <div v-if="state === 17" data-aos="fade-down">
            <!-- registračný slide  -->
            <div class="iframeWrapper">
              <iframe class="desktopCreatopy"
                      src="https://live-tag.creatopy.net/designs/6m03rzr/embed/standard/index.html?hash=1y320qe&amp;width=1080&amp;height=1080&amp;t=1671561650150&amp;userId=39667&amp;network=STANDARD&amp;type=html5&amp;responsive=true&amp;oref="
                      frameborder="0" allow="autoplay" allowtransparency="true" scrolling="no"
                      allowfullscreen="">
              </iframe>

              <iframe class="smartphonepCreatopy"
                      src="https://live-tag.creatopy.net/designs/wlg3kw0/embed/standard/index.html?hash=1y320qe&amp;width=1080&amp;height=1080&amp;t=1671561650150&amp;userId=39667&amp;network=STANDARD&amp;type=html5&amp;responsive=true&amp;oref="
                      frameborder="0" allow="autoplay" allowtransparency="true" scrolling="no"
                      allowfullscreen="">
              </iframe>
              <div class="income-calculator finalCtaBanner">
                <div class="businessCard">
                  <div class="businessCardPhoto"></div>
                  <div class="businessCardContact">
                    <div class="businessCardName">Mgr. Michaela Rosochová</div>
                    <a href="tel:+421940610948" class="businessCardContactCorvus">0940 610 948</a>
                  </div>
                </div>
                Zaujíma vás výška splátky? Registrujte sa teraz a nenechajte si ujsť aktuálnu zľavu až 34 000 € na byt v
                Corvus Malacky. Ste len krok od získania hypotéky a nového bývania.
              </div>
            </div>
            <div class="registerCtaWrapper">
              <div class="next-btn g-btn" @click="openGoogle">
                <div class="googleLogo">
                  <img
                      src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/64cde57a9e1879e4a804d00b_google%20icon.svg"
                      alt="">
                </div>
                <div>registrácia s Google</div>
              </div>

              <div class="secondary-btn" @click="collapsedRegistration = !collapsedRegistration">
                registrácia emailom
              </div>

              <b-collapse class="analyzaForm" v-model="collapsedRegistration">
                <div>
                  <input autocomplete="nope" v-model="formData.user.email"
                         placeholder="Prihlasovací email:"
                         type="text" class="questioner-input">

                </div>
                <div class="position-relative">
                  <input autocomplete="nope" v-model="formData.user.password1"
                         placeholder="Heslo:" id="Password"
                         type="password" class="questioner-input">

                  <i
                      class="eye"
                      id="eye-wrapper"
                      @click="shPass = !shPass"
                  ></i>
                </div>
                <div class="inline-div MGtop20px">
                  <button :disabled="!canContinue"
                          v-on="state === 17 ? {click: register} : {click: next}"
                          class="next-btn g-btn"
                  >
                    <div v-if="fullfilling" class="margin-right"><span
                        class="spinner-border spinner-border-sm text-secondary"
                        role="status" aria-hidden="true"
                        style="color: white!important;"></span></div>
                    <span>Registrovať</span>

                  </button>
                </div>
              </b-collapse>
            </div>
          </div>

          <div v-if="state === 18" data-aos="fade-down">
            <!-- zhrnutie screen manager príjmov -->
            <div class="questionare-title MGbottom20px">
              <div class="question-step" v-if="seenSideIncomeOptions">Zhrnutie:</div>
              <div class="question-step" v-else>Budete na hypotéku dvaja?</div>
            </div>
            <div
                style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
                class="answers-block">
              <b-overlay :show="fullfilling">
                <Button v-if="!responseData.incomes.applicant.length" :value="'applicant'"
                        :inner="'Pridať príjem žiadateľa'" @select="handleEvent($event)" :next="3"></Button>

                <div v-else class="incomes-wrapper">
                  <div class="questionare-text bold">Príjmy žiadateľa</div>

                  <div class="DTIwrapper" v-for="(income, index) in responseData.incomes.applicant"
                       :key="`applicant-income-${index}`">
                    <income-item :type="income.druh"
                                 :diets="income['suma_diet'] ? {value: income['suma_diet'], frequency: income['frekvencia']} : null"
                                 :value="income.suma"
                                 @delete="deleteIncome($event)" :id="income.id"
                                 @update="updateIncome($event); formData.income.client = 'applicant'"></income-item>
                  </div>

                  <div class="cta-text-small custom-link"
                       style="width: fit-content; margin: 1rem 0;" @click="handleEventRawElement($event.target)"
                       value="applicant" next="3">+ pridať môj ďalší PRÍJEM
                  </div>
                  <div class="cta-text-small custom-link" v-if="seenSideIncomeOptions"
                       style="width: fit-content; margin: 1rem 0;" @click="handleEventRawElement($event.target)"
                       value="applicant" next="11">+ pridať môj ďalší vedľajší PRÍJEM
                  </div>
                </div>
              </b-overlay>

              <b-overlay :show="fullfilling">
                <Button v-if="!responseData.incomes.coApplicant.length" :value="'coapplicant'"
                        :inner="'Pridať príjem spolužiadateľa'" @select="handleCoApplicant"
                        :next="7"></Button>

                <div v-else class="incomes-wrapper">
                  <div class="questionare-text bold" style="padding-bottom: 1rem">Príjmy spolužiadateľa</div>

                  <div class="DTIwrapper">
                    <income-item v-for="(income, index) in responseData.incomes.coApplicant" :type="income.druh"
                                 :id="income.id" :value="income.suma"
                                 :diets="income['suma_diet'] ? {value: income['suma_diet'], frequency: income['frekvencia']} : null"
                                 :key="`coapplicant-income-${index}`" @delete="deleteIncome($event)"
                                 @update="updateIncome($event); formData.income.client = 'coapplicant'"></income-item>
                  </div>

                  <div class="cta-text-small custom-link"
                       style="width: fit-content; margin: 1rem 0;" @click="handleEventRawElement($event.target)"
                       value="coapplicant" next="7">+ pridať ďalší PRÍJEM
                  </div>
                  <div class="cta-text-small custom-link" v-if="seenSideIncomeOptions"
                       style="width: fit-content; margin: 1rem 0;" @click="handleEventRawElement($event.target)"
                       value="coapplicant" next="11">+ pridať ďalší vedľajší PRÍJEM
                  </div>
                </div>
              </b-overlay>
            </div>
          </div>

          <div v-if="state === 19" data-aos="fade-down">
            <!-- príjem z diét slide (zadávanie diét) -->
            <div class="questionare-title MGbottom20px">
              <div class="question-step" v-html="form[state].title">
              </div>
            </div>

            <div class="overflowWrapper">
              <div v-for="(month, index) in formData.dietaLastMonths.slice(0, formData.lastMonths.length)"
                   :key="`dieta-${index}`">
                <value-input
                    months
                    :init-value="month.value"
                    :data-ref="`dietaLastMonths[${index}].value`"
                    :key="`dieta-i-${index}`"
                    :title="month.name"
                    :min="0"
                    @change="handleEvent($event)"
                ></value-input>
              </div>
            </div>
          </div>

          <div v-if="state === 20" data-aos="fade-down">
            <!-- výber komu ideme pridať vedľajší príjem  -->
            <div class="questionare-title MGbottom20px">
              <div class="question-step">
                Koho vedľajší príjem ideme pridať ?
              </div>
            </div>
            <div>
              <Button @select="handleEvent($event)" :next="formData.income.sideIncome.sideIncomeStates[0]"
                      :inner="'Žiadateľa'" :value="'applicant'"></Button>
              <Button @select="handleEvent($event)" :next="formData.income.sideIncome.sideIncomeStates[1]"
                      :inner="'Spolužiadateľa'" :value="'coapplicant'"></Button>
            </div>
          </div>

          <div v-if="state === 21" data-aos="fade-down">
            <!-- Dostávate aj diéty ? -->
            <div class="questionare-title MGbottom20px">
              <div class="question-step" v-html="form[state].title">
              </div>
            </div>

            <div>
              <Button @select="handleEvent($event)" :next="19"
                      inner="Áno" :value="true"></Button>
              <Button
                  @select="handleEvent($event);"
                  :next="18"
                  inner="Nie"
                  :value="false"
              ></Button>
            </div>
          </div>

          <div v-if="state === 22" data-aos="fade-down">
            <!-- vedľajší príjem z rodičovského príspevku -->
            <div class="questionare-title MGbottom20px">
              <div class="question-step">
                Príjem z <span class="green">rodičovského príspevku</span>
              </div>
            </div>

            <div class="income-calculator">
              <income-displayer :income="formData.income.sideIncome.materska_rodicovsky_prispevok"
                                :fullfilling="fullfilling"></income-displayer>

              <div
                  class="questionare-text mini MGtop10px">*v prípade ak ste mali vyplácanú materskú tak sa rodičovský
                príspevok zvyšuje na 473.30 EUR
              </div>
            </div>

            <div>
              <div class="infoBaner">Mali ste vyplácanú materskú ?</div>

              <Button inner="Áno" @select="handleEvent($event)" :next="18" :value="true" data-ref="materska"
              ></Button>
              <Button inner="Nie" @select="handleEvent($event)" :next="18" :value="false" data-ref="materska"
              ></Button>
            </div>
          </div>

          <div v-if="state === 23" data-aos="fade-down">
            <!-- americká hypotéka bezúčel  -->
            <div class="questionare-title"></div>
            <div
                style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
                class="answers-block">
              <div class="income-calculator">
                <div
                    class="questionare-text MGbottom10px">hodnota nehnuteľnosti, ktorú plánujete založiť:
                </div>
                <!--                <div-->
                <!--                    class="questionare-text bold big">{{ formData.propertyValue.toLocaleString() }} EUR-->
                <!--                </div>-->
                <invisible-input v-model="formData.propertyValue" type="number" :min="0" :max="1000000"
                                 after="EUR"></invisible-input>

                <slider :value-prop="formData.propertyValue" :step="1000" :min="0" :max="1000000"
                        @change="handleEvent($event)"
                        data-ref="propertyValue"></slider>
              </div>
              <div class="income-calculator">
                <div class="questionare-text MGbottom10px">požadovaná výška úveru:
                </div>
                <div class="div-block-87">
                  <div
                      class="questionare-text bold big">
                    {{ formData.mortgage.suma_bezucel ? formData.mortgage.suma_bezucel.toLocaleString() : 0 }} EUR
                  </div>
                  <div class="ltvSelector">
                    <div class="arrows" style="user-select:none;">
                      <svg @click="handleLtvChange(true)" class="ltv-control" style="user-select:none;" width="11"
                           height="8"
                           viewBox="0 0 11 8" fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 6.5L5.5 2L1 6.5" stroke-width="2"/>
                      </svg>

                      <svg @click="handleLtvChange(false)" class="ltv-control" style="user-select:none;" width="11"
                           height="7"
                           viewBox="0 0 11 7" fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L5.5 5.5L10 1" stroke-width="2"/>
                      </svg>

                    </div>
                    <div class="questioner-text bold" style="user-select:none;">{{ LTV ? parseInt(LTV) : 0 }}%</div>
                  </div>
                </div>
                <slider :value-prop="formData.mortgage.suma_bezucel" :data-ref="'mortgage.suma_bezucel'"
                        :step="1000" :min="0"
                        :max="(formData.propertyValue * 0.9) + 1000"
                        @change="handleEvent($event)">
                </slider>
                <div
                    class="questionare-text mini">*úver je možné v niektorých bankách žiadať až do výšky 90% hodnoty
                  založených nehnuteľností
                </div>
              </div>
            </div>
          </div>

          <div v-if="state === 24" data-aos="fade-down">
            <div class="questionare-title">
              <div class="question-step"><span class="font-weight-bold">Čo chcete zmeniť</span> na starých úveroch?
              </div>
            </div>

            <Button value="refinancovanie" inner="Zafixovať nový úrok" @select="handleEvent($event)"></Button>
            <Button value="konsolidacia" inner="Zlúčiť úvery do jedného výhodnejšieho"
                    @select="handleEvent($event)"></Button>

          </div>

          <div v-if="state === 25" data-aos="fade-down">
            <!-- refinancovanie zlúčenie úverov do jedného -->
            <div class="questionare-title">
              <div class="question-step">Doplňte <span class="font-weight-bold">parametre Vašej hypotéky</span></div>
            </div>

            <div data-w-id="53a1566e-b396-ebaa-01ff-c126de71b561"
                 style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
                 class="answers-block">
              <value-input title="splátka" :min="0" after="EUR" data-ref="debt.splatka"
                           :init-value="formData.debt.splatka" @change="handleEvent"></value-input>

              <value-input :min="0" title="orientačný zostatok" after="EUR" data-ref="debt.zostatok"
                           :init-value="formData.debt.zostatok" @change="handleEvent"></value-input>

              <value-input :max="100" :min="0" :interval="0.01" title="úrok (nepovinné)" after="%" data-ref="debt.sadzba"
                           :init-value="formData.debt.sadzba" @change="handleEvent"></value-input>
            </div>
            <!-- <div class="infoBaner">
              *neviete zostatok hypotéky? nechajte pole prázdne a v ďalšom kroku Vám ho vyrátame
            </div> -->
          </div>

          <div v-if="state === 26" data-aos="fade-down">
            <!-- výpočet zostatku hypotéky -->
            <div class="questionare-title MGbottom20px">
              <div class="question-step">Pre <span
                  class="green">výpočet zostatku</span> hypotéky doplňte:
              </div>
            </div>

            <div
                style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
                class="answers-block">

              <div class="income-calculator">
                <div class="questionare-text MGbottom10px">Ako dlho už splácate?</div>
                <date-picker title="začiatok" id="date-picker-3" class="my-2" @change="handleEvent"
                             data-ref="debt.temp.zaciatok"
                             :init-value="formData.debt.zaciatok"></date-picker>
              </div>

              <value-input :interval="1" :min="1" :max="40" title="splatnosť" after="rokov"
                           data-ref="debt.splatnost"
                           :init-value="formData.debt.splatnost" @change="handleEvent"></value-input>

              <value-input :min="0" title="počiatočný objem" after="EUR" data-ref="debt.temp.suma"
                           :init-value="formData.debt.temp.suma" @change="handleEvent"></value-input>

              <dropdown-select :options="[
                  {
                    text: '5',
                    value: 5
                  },
                  {
                    text: '10',
                    value: 10
                  },
                  {
                    text: '15',
                    value: 15
                  },
                  {
                    text: '20',
                    value: 20
                  },
                  {
                    text: '25',
                    value: 25
                  },
                  {
                    text: '30',
                    value: 30
                  }
              ]" data-ref="debt.temp.den_splatky" name="deň splátky" :init-value="formData.debt.temp.den_splatky"
                               :id="0" @select="handleEvent"></dropdown-select>

              <div class="infoBaner">
                *zostatok k tomuto mesiacu by mal činiť:
              </div>

              <value-input readonly class="my-2" :min="0" title="zostatok" after="EUR"
                           data-ref="debt.zostatok"
                           :init-value="formData.debt.zostatok" :fullfilling="fullfilling"></value-input>
            </div>
          </div>

          <div v-if="state === 27" data-aos="fade-down">
            <div class="questionare-title">
              <div class="question-step">Orientačný súčet zostatkov ostatných zlučovaných úverov</div>
            </div>

            <div
                style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
                class="answers-block">
              <div class="income-calculator">
                <!--                <div class="questionare-text bold big">-->
                <!--                  {{ formData.debt.meta.orientacny_sucet.toLocaleString() }} EUR-->
                <!--                </div>-->
                <invisible-input v-model="formData.debt.meta.orientacny_sucet" type="number" :min="0" :max="1000000"
                                 after="EUR">
                </invisible-input>


                <slider @change="handleEvent" :min="0" :max="1000000" id="0" :step="1000"
                        :value-prop="formData.debt.meta.orientacny_sucet"
                        data-ref="debt.meta.orientacny_sucet"></slider>

                <div class="infoBaner">
                  *v prípade ak chcete refinancovať len uvedenú hypotéku, preskočte tento krok
                </div>
              </div>
            </div>
          </div>

          <div v-if="state === 28" data-aos="fade-down">
            <swiper ref="mySwiper" :options="swiperOptions">
              <swiper-slide>
                <div class="questionare-title">
                  <div class="question-step center">Reálne ponuky financovania <span class="green">s 99% presnosťou</span></div>
                </div>
                <img class="registrationBanner" src="https://cdn.prod.website-files.com/648b04f9d8e52d9524912b4a/6836d8683eaf22b439be1b23_bannerRegistration1.png">

              </swiper-slide>

              <swiper-slide>
                <div class="questionare-title">
                  <div class="question-step center">Majte svojho <span class="green">osobného bankára</span> vždy po
                    ruke
                  </div>
                </div>
                <img class="registrationBanner" src="https://cdn.prod.website-files.com/648b04f9d8e52d9524912b4a/6836d868a0589aeb0795f846_bannerRegistration5.png">
              </swiper-slide>
              <swiper-slide class="onlnyDeafult">
                <div class="questionare-title">
                  <div class="question-step center">Objavujte <span class="green">tisícky ponúk bývania</span> na našej mape
                  </div>
                </div>
                <img class="registrationBanner" src="https://cdn.prod.website-files.com/648b04f9d8e52d9524912b4a/6836d8690cc164a441c4d404_bannerRegistration6.png">
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>

            <div class="overenieWrapper">
              <input autocomplete="nope" v-model="formData.user.telephone"
                     placeholder="09..."
                     pattern="[0-9]{4} [0-9]{3} [0-9]{3}"
                     type="tel" class="questioner-input green">
              <div style="text-align: center">na overenie, ktoré prebieha formou SMS kódu, zadajte telefónne číslo a kliknite na ďalej</div>
            </div>
          </div>

          <div v-if="state === 29" data-aos="fade-down">
            <div class="questionare-title">
              <div class="question-step">Do SMS Vám práve dorazil <span class="green">6-miestny kód</span></div>
            </div>
            <div>kód pre overenie sme Vám poslali na číslo: {{ formData.user.telephone }}, pozrite sa do správ 📲</div>

            <div style="margin-top: 40px">
              <otp-input
                  ref="otpInput"
                  input-classes="otp-input"
                  :num-inputs="6"
                  separator=""
                  :should-auto-focus="true"
                  :is-input-num="true"
                  @on-complete="register"
                  style="gap: 15px; justify-content: center"
              />
            </div>

            <div class="groupofBtns" style="text-align: center; margin-top: 40px">
              <button class="secondary-btn MGtop20px" @click="clearInput">Vymazať</button>
              <button class="next-btn MGtop20px" style="width: 100%;">Pokračovať</button>
            </div>
          </div>

          <div class="div-block-54 MGtop20px" v-if="form[state].canControl && ![3,7,20].includes(state)">
            <div @click="back" class="back-btn" :class="{'visibility-hidden': hideBackButton}">späť</div>
            <button :disabled="!canContinue"
                    v-on="state === 29 ? {click: register} : {click: next}"

                    :class="{
                      'hide': state === 29,
                      'next-btn': state !== 29,
                      'prijem_zadany': state === 18,
                      'dti_vypocitane': state === 16,
                    }"
            >
              <div>
                {{ state === 18 && seenSideIncomeOptions ? 'Dokončiť' : state === 16 ? 'Ponuky' : 'Ďalej' }}
              </div>
            </button>
          </div>

          <div
              v-else-if="(state === 16 && formData.mortgage.hlavny_ucel === 'bezucel') || [3,7,18,20,24].includes(state)"
              class="div-block-54 MGtop20px">
            <div @click="back" class="back-btn">späť</div>
          </div>
        </div>
      </div>
      <a href="https://www.bankari.sk" target="_blank" class="affiliateBadgeV2">
        <img class="darkBadgeV2"
             src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/655329153dfa77637ac4d1c7_powered%20by.svg">
        <img class="lightBadgeV2"
             src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/65533c07476243fbff41ad58_powered%20by%20white.svg">
      </a>
      <chat></chat>
    </div>
    <a href="https://www.bankari.sk" target="_blank" class="affiliateBadge">
      <img class="darkBadge"
           src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/655329153dfa77637ac4d1c7_powered%20by.svg">
      <img class="lightBadge"
           src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/65533c07476243fbff41ad58_powered%20by%20white.svg">
    </a>
  </div>
</template>

<script>
import Button from "./Button";
import Slider from "./Slider";
import ValueInput from "./ValueInput";
import Chat from "./Chat";
import {required, email, sameAs, helpers} from 'vuelidate/lib/validators';
import ApiController from "../mixins/ApiController";
import IncomeItem from "./IncomeItem";
import IncomeDisplayer from "./IncomeDisplayer";
import DropdownSelect from "./DropdownSelect";
import structuredClone from "@ungap/structured-clone";
import DatePicker from "./DatePicker";
// import BannerRemarketing from "./BannerRemarketing";
import InvisibleInput from "@/components/InvisibleInput.vue";

function initFormData() {
  return {
    wayOfCalculatingPoistne: "dont-know",
    hasDiets: false,
    materska: false,

    mortgage: {
      //Len pre interne účely appky, pri posielani sa tento attr deletne
      hlavny_ucel: null,
      ciel_prva_analyza: null,

      own_funds: 0,

      suma_nadobudnutie: 0,
      suma_bezucel: 0,
      suma_refinancovanie: 0,
      refinancovane_dlhy: [],

    },

    propertyValue: 0,

    debt: {
      zostatok: null,
      id: null,
      splatka: null,
      splatnost: null,
      sadzba: null,
      is_active: false,
      is_visible: true,


      //veci na kalkulacie
      temp: {
        suma: null,
        den_splatky: null,
        zaciatok: null,
        //this.formData.debt.splatnost * 12
        mesiace: null
      },

      meta: {
        orientacny_sucet: 0,
      }
    },

    income: {
      //Date
      incomeFrom: null,

      parentalContribution: false,

      client: null,

      selfEmployed: {
        trzby: null,
        minulorocne_vydavky: null,
        pausalne_vydavky: "",
        rocne_poistne: null
      },

      company: {
        trzby: null,
        zisk: null,
        podiel: null
      },

      mainIncome: {
        typ: "hlavny",
        suma: 0,
        druh: null,

        // suma_diet: 0,
        // frekvencia: null
      },

      sideIncome: {
        //Nech viem, na aky states chceme isť pri prvom prechadzani
        sideIncomeStates: [],

        prijem_z_prenajmu_nehnutelnosti: 0,

        starobny_dochodca: null,
        vysluhovy_dochodca: null,
        invalidny_dochodca_v_sr: null,
        vdovsky_dochodca: null,

        materska_rodicovsky_prispevok: null
      },
    },

    lastMonths: [],

    dietaLastMonths: [],

    user: {
      email: null,
      password1: null,
      password2: null,
      telephone: null,
    },
  }
}

export default {
  name: "Calculator",
  components: {
    InvisibleInput,
    ValueInput,
    Button,
    Slider,
    Chat,
    IncomeItem,
    IncomeDisplayer,
    DropdownSelect,
    DatePicker,
    // BannerRemarketing
  },
  mixins: [ApiController],
  data: () => ({
    swiperOptions: {
      pagination: {
        el: '.swiper-pagination'
      },
      autoplay: {
        delay: 2000,
      },
    },

    shPass: false,
    eye: null,

    LTV: 0,

    vydavkyCollapsed: false,
    poistneCollapsed: true,

    state: 0,
    history: [],
    seenSideIncomeOptions: false,
    collapsedRegistration: false,

    form: [
      {//0
        canControl: false,
        dataRef: "mortgage.ciel_prva_analyza",
        //pre posledny button storujeme preto next tu, lebo sa meni dynamicky
        next: 3
      },
      {//1
        canControl: true,
        next: 3,
      },
      {//2 - nepoužíva sa
        canControl: true,
        next: 3,
      },
      {//3
        canControl: true,
        dataRef: "income.mainIncome.druh",
      },
      {//4
        canControl: true,
        next: 21,
        condition: ["lastMonths[0].value", "lastMonths[1].value", "lastMonths[2].value"]
      },
      {//5
        condition: ["income.selfEmployed.trzby", "custom-szco"],
        canControl: true,
        next: 18,
      },
      {//6
        condition: ["income.company.trzby", "income.company.zisk", "income.company.podiel"],
        canControl: true,
        next: 18,
      },
      {//7
        canControl: true,
        dataRef: "income.mainIncome.druh"
      },
      {//8
        canControl: true,
        condition: ["lastMonths[0].value", "lastMonths[1].value", "lastMonths[2].value"],
        next: 21,
      },
      {//9
        condition: ["income.selfEmployed.trzby", "income.selfEmployed.rocne_poistne", "custom-szco"],
        canControl: true,
        next: 18,
      },
      {//10
        condition: ["income.company.trzby", "income.company.zisk", "income.company.podiel"],
        canControl: true,
        next: 18,
      },
      {//11
        displayName: "Máte aj <strong>vedľajší príjem?</strong>",
        dataRef: "income.sideIncome.sideIncomeStates",
        canControl: true,
        next: 18
      },
      {//12
        condition: ["income.sideIncome.prijem_z_prenajmu_nehnutelnosti", "income.incomeFrom"],
        canControl: true,
        next: 18,
      },
      {//13
        condition: ["income.sideIncome.prijem_z_prenajmu_nehnutelnosti", "income.incomeFrom"],
        canControl: true,
        next: 18,
      },
      {//14
        canControl: true,
        next: 18,
      },
      {//15
        canControl: true,
        next: 18,
      },
      {//16
        canControl: true,
        next: 28,
        dataRef: "mortgage.hlavny_ucel"
      },
      {//17
        canControl: true,
        condition: ["user.email", "user.password1", "user.password2"]
      },
      {//18 - manager príjmov
        canControl: true,
        next: 11,
        dataRef: "income.client",
        //Ak používame prefix custom odkazujeme na vlastné validácie kt. ďalej handlíme v canContinue
        condition: ["custom-incomes"]
      },
      {//19
        title: "",
        condition: ["custom-diety"],
        canControl: true,
        next: 18
      },
      {//20
        dataRef: "income.client",
        canControl: true,
      },
      {//21
        title: "",
        dataRef: "hasDiets",
        canControl: false,
      },
      {//22
        dataRef: "sideIncome.suma",
        canControl: true,
        next: 18
      },

      //23 americka hypo
      {
        canControl: true,
        dataRef: "",
        condition: [
          "propertyValue",
          "mortgage.suma_bezucel"
        ],
        next: 3
      },

      //24
      {
        canControl: false,
        //keď je true po firnuti handleEvent sa presuvame na state definovany tu
        nextOnChange: true,
        next: 25,
        dataRef: "mortgage.ciel_prva_analyza",
      },
      //25
      {
        condition: [
          "debt.splatka",
          "debt.zostatok"
        ],

        canControl: true,
        dataRef: "",
        next: 3
      },

      {//26
        canControl: true,
        condition: [
          "debt.zostatok"
        ],
        next: 27,
      },
      {//27
        canControl: true,
        condition: [
          "debt.meta.orientacny_sucet"
        ],
        next: 3
      },
      {//28 - twilio odoslanie kodu
        canControl: true,
        condition: [
          "user.telephone"
        ],
        next: 29
      },
      {//29 - overenie čísla
        canControl: false,
      }
    ],

    formData: initFormData(),

    allMonths: [],

    tooltipOptions: {
      position: "top",
      title: ""
    },

    errMsg: "",

    collapseMap: [
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
    ],
    collapsing: false,
    //TODO: Potrebujeme to ešte ?
    dismissCountDown: 0,
    dismissSec: 5,
    error: ""
  }),
  validations: {
    formData: {
      user: {
        email: {required, email},
        password1: {required},
        password2: {required, sameAsPassword: sameAs('password1')},
        telephone: {required, validTelephone: helpers.regex('phone', /^09\d{8}$/)},
      },
    }
  },
  async created() {
    //Pred zatvorením sa pošlu data do GTM
    // window.addEventListener('beforeunload', () => {
    //   this.sendDataToGTM("client-left");
    // }, false);

    const urlParams = new URLSearchParams(window.location.search);
    const ucel = urlParams.get('ucel');
    const suma = urlParams.get('suma');

    if(ucel && ucel === 'nadobudnutie') {
      this.state = 1;
      this.formData.mortgage.ciel_prva_analyza = 'nadobudnutie';

      if(suma && !isNaN(Number(suma))) {
        this.formData.propertyValue = suma;
      }
    } else if (Object.keys(this.firstQuestionDisabledOrigins).includes(window.location.origin)) {

      this.state = this.firstQuestionDisabledOrigins[window.location.origin].state;
      this.formData.mortgage.ciel_prva_analyza = this.firstQuestionDisabledOrigins[window.location.origin].purpose;
    }

    this.setMonths();

    try {
      await this.setClientData();

      this.$store.commit("setClientId", this.applicant.id);
      this.$store.commit("initIsCompleted");

      if (this.applicant.client_profile.twilio_verified)
        this.form[16].canControl = false;
      else
        this.form[16].next = 28;

      this.initializingData = true;
      await this.afterInit();
      this.initializingData = false;
    } catch {
      console.error("Užívateľ nemá platné cookies");
    }
  },
  methods: {
    getRefresh() {
      return this.$store.getters.getRefresh;
    },

    clearInput() {
      this.$refs.otpInput.clearInput();
    },

    toggleCalculator() {
      var hiddenElement = document.querySelector(".calculator");
      hiddenElement.classList.toggle("active");
      var hiddenElementTrigger = document.querySelector(".showCalculator");
      hiddenElementTrigger.classList.toggle("active");
      var hiddenElementTriggerIcon = document.querySelector(".showCalculatorIcon");
      hiddenElementTriggerIcon.classList.toggle("active");
      var hiddenElementTriggerText = document.querySelector(".showCalculatorText2");
      hiddenElementTriggerText.classList.toggle("active");
    },

    openGoogle() {
      location.href = process.env.NODE_ENV === 'production' ? 'https://accounts.google.com/o/oauth2/v2/auth?redirect_uri=https://app.bankari.sk/google-auth-redirect/&prompt=consent&response_type=code&client_id=792639611149-beq2n8hgmush3e79a5umo60c1vnp6be9.apps.googleusercontent.com&scope=openid%20email%20profile&access_type=offline' : 'https://accounts.google.com/o/oauth2/v2/auth?redirect_uri=https://bankari-staging.web.app/google-auth-redirect/&prompt=consent&response_type=code&client_id=634236765018-aqkqkcgs7obg4d2cj0bf0vhd56ut9nfn.apps.googleusercontent.com&scope=openid email profile&access_type=offline';
      // location.href ='https://accounts.google.com/o/oauth2/v2/auth?redirect_uri=https://bankari-staging.web.app/google-auth-redirect/&prompt=consent&response_type=code&client_id=634236765018-aqkqkcgs7obg4d2cj0bf0vhd56ut9nfn.apps.googleusercontent.com&scope=openid email profile&access_type=offline';
    },

    handleCoApplicant(e) {
      this.handleEvent(e);
      if (!this.coApplicant)
        this.addCoApplicant();
    },

    handleLtvChange(plus) {
      if (plus && this.LTV < 90)
        this.LTV = Math.ceil((this.LTV + 1) / 10) * 10;
      else if (!plus && this.LTV > 0)
        this.LTV = Math.ceil((Math.floor(this.LTV) - 10) / 10) * 10;
    },
    setMonths() {
      let currentDate = new Date();

      this.allMonths = [];
      this.formData.lastMonths = [];

      for (let i = 0; i < 12; i++) {
        const newMonth = currentDate.getMonth() - 1;
        let oldMonth = currentDate.getMonth();
        currentDate.setMonth(newMonth);

        if (oldMonth === currentDate.getMonth())
          currentDate.setMonth(newMonth);

        const monthToPush = currentDate.toLocaleString('default', {month: 'long', year: 'numeric'});
        this.allMonths.push({
          name: monthToPush.charAt(0).toUpperCase() + monthToPush.charAt(1) + monthToPush.charAt(2) + " " + monthToPush.slice(monthToPush.length - 4),
          value: null,
          date: new Date(currentDate)
        });

        if (i < 10)
          this.formData.dietaLastMonths.push({
            name: monthToPush,
            value: null,
            date: new Date(currentDate)
          });
      }

      currentDate = new Date();

      for (let i = 0; i < 3; i++) {
        const newMonth = currentDate.getMonth() - 1;
        let oldMonth = currentDate.getMonth();
        currentDate.setMonth(newMonth);

        if (oldMonth === currentDate.getMonth())
          currentDate.setMonth(newMonth);

        const monthToPush = currentDate.toLocaleString('default', {month: 'long', year: 'numeric'});

        this.formData.lastMonths.push({
          name: monthToPush.charAt(0).toUpperCase() + monthToPush.charAt(1) + monthToPush.charAt(2) + " " + monthToPush.slice(monthToPush.length - 4),
          value: null,
          date: new Date(currentDate)
        });
      }
    },
    resetFormData() {
      this.responseData.banks = [];
      this.formData = initFormData();

      if (!this.coApplicant)
        this.formData.income.client = "applicant";

      this.loadData();

      this.setMonths();
    },

    //TODO: Alert
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    expandNewMonth() {
      this.$set(this.formData.lastMonths, this.formData.lastMonths.length, this.allMonths[this.formData.lastMonths.length]);
    },
    handleEventRawElement(e) {
      const object = {
        dataRef: e.attributes.getNamedItem("data-ref") ? e.attributes.getNamedItem("data-ref").value : null,
        value: e.attributes.getNamedItem("value").value,
        next: Number(e.attributes.getNamedItem("next").value),
      };

      this.handleEvent(object);
    },
    handleEvent(e, callback = null) {
      if (e.dataRef)
        this.accessNested(e.dataRef, e.value, true);
      else
        this.accessNested(this.form[this.state].dataRef, e.value, true);

      if (e.next || (this.form[this.state].next && this.form[this.state].nextOnChange)) {
        if (![21, 19].includes(this.state))
          this.history.push(this.state);

        if (e.next)
          this.state = e.next;
        else
          this.state = this.form[this.state].next;
      }

      if (callback)
        callback();
    },
    accessNested(path, value, setter) {
      let schema = this.formData;
      let pList = path.split(".");

      pList.forEach((path, index, array) => {
        if (path.includes("[")) {
          const schemaIndex = path.split("[")[1].charAt(0);
          array[index] = path.split("[")[0];
          array.splice(index + 1, 0, schemaIndex);
        }
      });

      for (let i = 0; i < pList.length - 1; i++) {
        let elem = pList[i];
        if (!schema[elem]) schema[elem] = {}
        schema = schema[elem];
      }

      if (setter) this.$set(schema, pList[pList.length - 1], value);
      else
        return schema[pList[pList.length - 1]];
    },
    back() {
      this.state = this.history[this.history.length - 1];
      this.history.pop();

      this.$nextTick(() => {
        window.scrollTo(0, 0);
      });
    },
    async next() {
      if ([9, 5, 6, 10].includes(this.state)) {
        let interval;
        await new Promise((res, rej) => {
          interval = setInterval(() => {
            if (this.formData.income.mainIncome.suma)
              res()
          }, 50);

          setTimeout(() => {
            rej("timed out");
          }, 3000);
        });

        clearInterval(interval);
      }

      if (![21, 19].includes(this.state))
        this.history.push(this.state);

      this.state = this.form[this.state].next;

      this.$nextTick(() => {
        window.scrollTo(0, 0);
      });
    },
    hideMonth() {
      this.collapsing = true;

      this.$set(this.collapseMap, this.formData.lastMonths.length - 1, false);

      setTimeout(() => {
        this.collapsing = false;

        let hadValue = Boolean(this.formData.lastMonths[this.formData.lastMonths.length - 1].value || this.formData.lastMonths[this.formData.lastMonths.length - 1].value === 0);

        this.formData.lastMonths.pop();

        if (hadValue)
          this.getAverageIncome();
      }, 300);
    },
    updateIncome(id) {
      //pushneme manager prijmov
      this.history.push(18);

      this.incomeToUpdate = id;

      //ak je id Array idčok dôchodkov
      if (typeof id === "object") {
        id.forEach(id => {
          const income = [...this.applicant.incomes, ...this.coApplicant.incomes].filter(income => income.id === id)[0];
          this.formData.income.sideIncome[income.druh] = income.suma;
        });

        this.state = 14;
      } else {
        const income = [...this.responseData.incomes.applicant, ...this.responseData.incomes.coApplicant].filter(income => income.id === id)[0];

        if (income.typ === "hlavny") {
          Object.keys(this.formData.income.mainIncome).forEach(key => {
            this.formData.income.mainIncome[key] = income[key];
          });

          switch (income.druh) {
            case "trvaly_pracovny_pomer": {
              const lastMonths = [];

              income["mesacne_prijmy"].forEach(monthlyIncome => {
                const date = new Date(monthlyIncome.rok, monthlyIncome.mesiac - 1, 1);
                const monthToPush = date.toLocaleString('default', {month: 'long', year: 'numeric'});

                if (monthlyIncome.suma)
                  lastMonths.push({
                    name: monthToPush.charAt(0).toUpperCase() + monthToPush.charAt(1) + monthToPush.charAt(2) + " " + monthToPush.slice(monthToPush.length - 4),
                    value: monthlyIncome.suma,
                    date: new Date(date)
                  });

                if (monthlyIncome.diety)
                  this.formData.dietaLastMonths.forEach(dieta => {
                    if (dieta.date.getFullYear() === date.getFullYear() && dieta.date.getMonth() === date.getMonth())
                      dieta.value = monthlyIncome.diety;
                  });
              });

              this.formData.lastMonths = lastMonths.reverse();

              this.state = 4;
              break;
            }
            case "prijem_zivnostnika":
              this.formData.income.selfEmployed = {
                rocne_poistne: income["szco_rocne_poistne"],
                trzby: income["minulorocny_obrat"],
                pausalne_vydavky: null,
                minulorocne_vydavky: null
              }

              if (income.pausalne_vydavky) {
                this.formData.income.selfEmployed.pausalne_vydavky = "true";
                this.formData.income.selfEmployed.minulorocne_vydavky = 0;
              } else {
                this.formData.income.selfEmployed.pausalne_vydavky = "false";
                this.formData.income.selfEmployed.minulorocne_vydavky = income["minulorocne_vydavky"]
              }

              this.state = 5;
              break;
            case "prijem_z_sro":
              this.formData.income.company = {
                trzby: income["minulorocny_obrat"],
                zisk: income["zisk_sro"],
                podiel: income["podiel_v_sro"]
              }

              this.state = 6;
              break;
          }
        } else {
          this.state = 12;

          this.formData.income.incomeFrom = new Date(income.zamestnanie_od);
          this.formData.income.sideIncome[income.druh] = income.suma;
        }
      }
    },
    async deleteIncome(id) {
      this.fullfilling = true;

      if (typeof id === "object") {
        const promises = [];

        id.forEach(id => {
          promises.push(this.$axios.delete(`client-income/${id}/`));
        });

        await Promise.all(promises);
      } else
        await this.$axios.delete(`client-income/${id}/`);

      await this.setClientData();

      this.fullfilling = false;
    },

    handleTooltip(applicantBool, coApplicantBool) {
      this.tooltipOptions.title = "";

      if (!applicantBool)
        this.tooltipOptions.title += "Žiadateľ musí mať aspoň 1 hlavný príjem !\n";
      if (!coApplicantBool)
        this.tooltipOptions.title += "Spolužiadateľ nemôže mať vedľajší príjem bez hlavného !\n";
    },

  },
  computed: {
    hideBackButton() {
      return Object.keys(this.firstQuestionDisabledOrigins).includes(window.location.origin)
          && this.state === this.firstQuestionDisabledOrigins[window.location.origin];
    },
    hasSideIncomeParentalContribution() {
      let incomes = [];

      if (this.coApplicant)
        incomes = [...this.applicant.incomes, ...this.coApplicant.incomes]
      else
        incomes = [...this.applicant.incomes];

      return !!incomes.filter(income => income.druh === "materska_rodicovsky_prispevok").length;
    },
    canContinue() {
      if (this.form[this.state].condition) {
        const bools = [];

        const conditions = structuredClone(this.form[this.state].condition);

        //Handlenie custom- validácií
        const customCondition = conditions.filter(condition => condition.includes("custom-"))[0];

        if (customCondition) {
          conditions.splice(conditions.indexOf(customCondition), 1);

          switch (customCondition) {
            case "custom-incomes": {
              const applicantBool = Boolean(this.responseData.incomes.applicant.filter(income => income.typ === "hlavny").length);
              // const coApplicantBool = Boolean(!(this.responseData.incomes.coApplicant.filter(income => income.typ === "vedlajsi").length && !this.responseData.incomes.coApplicant.filter(income => income.typ === "hlavny").length));

              this.handleTooltip(applicantBool, true);

              return applicantBool;
            }
            case "custom-szco":
              bools.push(this.formData.income.selfEmployed.pausalne_vydavky === "true" ? true : Boolean(this.formData.income.selfEmployed.minulorocne_vydavky));
              bools.push(this.formData.wayOfCalculatingPoistne === "dont-know" ? true : Boolean(this.formData.income.selfEmployed.rocne_poistne));
              break;
            case "custom-diety":
              return Boolean(this.formData.dietaLastMonths.filter(dieta => dieta.value).length);
          }
        }

        conditions.forEach((condition) => {
          bools.push(Boolean(this.accessNested(condition, null, false)));
        });

        let finalBool = Boolean(bools.length);

        bools.forEach((bool) => {
          finalBool = finalBool && bool;
        });

        return finalBool;
      }

      return true;
    },
    isPasswordValid() {
      return {
        valid: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\D]{8,}$/.test(this.formData.user.password1),
        length: this.formData.user.password1.length >= 8,
        hasSmall: /[a-z]/.test(this.formData.user.password1),
        hasCapital: /[A-Z]/.test(this.formData.user.password1),
        hasNumber: /\d/.test(this.formData.user.password1)
      }
    },
    maxPropertyValue() {
      if (this.applicant && this.responseData.DTI)
        return this.responseData.DTI / (this.LTV / 100);
      return 0;
    },
    maxIncreaseAmount() {
      if (this.formData.mortgage.suma_refinancovanie < this.responseData.DTI)
        return this.responseData.DTI - this.formData.mortgage.suma_refinancovanie;
      return 0;
    },

    // iframeSize() {
    //   if(window.innerWidth > 1200)
    //     return {
    //       width: "1200px",
    //       height: "400px"
    //     }
    //   else if(window.innerWidth > 700)
    //     return {
    //       width: "1200px",
    //       height: "628px"
    //     }
    //
    //   return {
    //     width: window.innerWidth + "px",
    //     height: "100%"
    //   }
    // }
  },
  watch: {
    "formData.user.password1"(to) {
      this.formData.user.password2 = to;
    },
    "applicant.incomes.length"(to) {
      if (to) {
        this.form[0].next = 18;
        this.form[1].next = 18;
        this.form[23].next = 18;
        this.form[27].next = 18;
      } else {
        this.form[0].next = 3;
        this.form[1].next = 3;
        this.form[23].next = 3;
        this.form[27].next = 3;
      }
    },
    seenSideIncomeOptions(to) {
      if (to) {
        this.form[18].next = 16;
        this.form[11].displayName = "Vyberte aký <strong>vedľajší príjem</strong>";
      } else {
        this.form[18].next = 11;
        this.form[11].displayName = "Máte aj <strong>vedľajší príjem ?</strong>";
      }
    },
    shPass(to) {
      const el = document.getElementById("Password");
      const againEl = document.getElementById("pass-again");

      if (to) {
        el.type = "text";
        againEl.type = "text";

        this.eye.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
            <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
            <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
        </svg>`;
      } else {
        el.type = "password";
        againEl.type = "password";

        this.eye.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-slash-fill" viewBox="0 0 16 16">
            <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z"/>
            <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z"/>
        </svg>`;
      }
    },
    "formData.income.selfEmployed.pausalne_vydavky"(to) {
      this.vydavkyCollapsed = to === "false";
    },
    "formData.mortgage.suma_nadobudnutie"(to) {
      this.formData.mortgage.own_funds = this.formData.propertyValue - to;

      this.LTV = (to / this.formData.propertyValue) * 100;
    },
    "formData.mortgage.suma_bezucel"(to) {
      this.formData.mortgage.own_funds = this.formData.propertyValue - to;

      this.LTV = (to / this.formData.propertyValue) * 100;
    },
    "formData.propertyValue"(to, from) {
      if (!from)
        this.LTV = 80;

      if (this.state === 1)
        this.formData.mortgage.suma_nadobudnutie = to * (this.LTV / 100);
      else if (this.state === 23)
        this.formData.mortgage.suma_bezucel = to * (this.LTV / 100);
    },
    LTV(to, from) {
      let ltv = to;

      if (ltv !== from) {
        if (ltv > 90)
          ltv = 90;
        else if (ltv < 0)
          ltv = 0;

        ltv = ltv / 100;

        if (this.state === 1)
          this.formData.mortgage.suma_nadobudnutie = this.formData.propertyValue * ltv;
        else this.formData.mortgage.suma_bezucel = this.formData.propertyValue * ltv;
      }
    },
    state(to, from) {
      switch (to) {
        case 0:
          this.history = [];
          break;
        case 3:
        case 8:
          this.formData.lastMonths = [this.allMonths[0], this.allMonths[1], this.allMonths[2]]
          this.collapseMap = [
            true,
            true,
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
          ]
          break;
        case 17:
          setTimeout(() => {
            this.eye = document.getElementById("eye-wrapper");

            this.eye.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-slash-fill" viewBox="0 0 16 16">
            <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z"/>
            <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z"/>
            </svg>`;
          }, 50);
          break;
          
        case 21:
          if (from === 4) {
            this.form[21].title = "Dostávate aj <span class='green'>cestovné náhrady </span>alebo<span class='green'> diéty?</span>";
            this.form[19].title = "Uveďte sumy, ktoré Vám boli vyplatené";
          } else {
            this.form[21].title = "Dostáva spolužiadateľ aj <span class='green'>cestovné náhrady </span>alebo<span class='green'>  diéty?</span>";
            this.form[19].title = "Uveďte sumy, ktoré boli <span class='font-weight-bold'>spolužiadateľovi</span> vyplatené";
          }
          break;
        case 29:
          this.trigger2fa();
      }
    },
    "formData.lastMonths.length"(to, from) {
      if (to >= from) {
        if (this.formData.lastMonths[to - 1].value || this.formData.lastMonths[to - 1].value === 0)
          this.getAverageIncome();

        setTimeout(() => {
          this.collapsing = true;
          this.$set(this.collapseMap, to - 1, true);

          setTimeout(() => {
            this.collapsing = false;
          }, 350);
        }, 50);
      }
    },

    "formData.wayOfCalculatingPoistne"(to) {
      this.poistneCollapsed = to !== "dont-know";
    }
  }
}
</script>

<style lang="scss">

.agentBannerImg{
  width: 200px;
  position: absolute;
  bottom: 0;
  right: 0;
  border-bottom-right-radius: 20px;
  overflow: hidden;
}

.tutorialBanner{
  position: relative;
  min-height: 200px;
  margin-bottom: 40px;
  background-color: #00AA5B;
  padding: 40px;
  border-radius: 10px;
}

.g-btn {
  padding: 0.5rem;
  background: #ffffff;
  border: solid 1px rgba(10, 25, 83, 1);
  border-radius: 6px;
  width: fit-content;
  display: flex;
  gap: 10px;
  cursor: pointer;
  margin-bottom: 10px;
}

.otp-input {
  width: 30px;
  height: 40px;
  border-radius: 5px;
  border: 1px solid #00AA5B;
  text-align: center;
  background-color: #edf5f7;

  &:focus {
    outline: 2px solid #00AA5B !important;
  }
}

.groupofBtns{
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: stretch;
  width: 100%;
  margin-bottom: 20px;
}

// ul {
//   list-style-type: none;
//   margin-block-start: 1em;
//   margin-block-end: 1em;
//   margin-inline-start: 0px;
//   margin-inline-end: 0px;
//   padding-inline-start: 0px;
//   unicode-bidi: isolate;
// }

.slide {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.registrationBanner {
  max-width: 70%;
  @media (max-width: 991px) {
    max-width: 50%;
  }
}

.question-step.center {
  text-align: center;
}

.analyza-grid {
  align-items: center;
}

.swiper-slide {
  text-align: center;
}

.swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: #00AA5B;
}

.swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {
  position: relative;
  margin-top: 20px;
}

.overenieWrapper{
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: stretch;
  gap: 10px;
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
}

// .questioner-input{
//   max-width: none !important;
//   width: 100% !important;
//   text-align: left !important;
// }

</style>